// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
ko.bindingHandlers.scroll = {
	updating: true,
	init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		(bindingContext as any).updating = true;
		ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
			$(window).off("scroll touchend");
			(bindingContext as any).updating = false;
		});
	},
	update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		const props = allBindingsAccessor().scrollOptions;
		const offset = props.offset ? props.offset : "0";
		const loadFunc = props.loadFunc;
		const load = ko.utils.unwrapObservable(valueAccessor());
		if (load) {
			element.style.display = "";
			$(window).on("scroll touchend", function () {
				if ($(document).height() - offset <= $(window).height() + $(window).scrollTop()) {
					if ((bindingContext as any).updating) {
						loadFunc();
						(bindingContext as any).updating = false;
					}
				} else {
					(bindingContext as any).updating = true;
				}
			});
		} else {
			element.style.display = "none";
			$(window).off("scroll touchend");
			(bindingContext as any).updating = false;
		}
	}
};
